import { useDefaultValue } from '@gef-ui/context-defaults';
import PropTypes from 'prop-types';
export const useDefaultComponentValue = ({ inProps, name })=>{
    const props = useDefaultValue({
        inProps,
        slice: 'MaterialComponents',
        components: [
            name
        ]
    });
    return props;
};
export const passSx = (sx = [])=>Array.isArray(sx) ? sx : [
        sx
    ];
export const sxPropType = PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.object,
        PropTypes.bool
    ])),
    PropTypes.func,
    PropTypes.object
]);
export const inlineButtonSx = {
    color: 'common.white',
    borderColor: 'common.white',
    '&:hover': {
        borderColor: 'common.white'
    }
};
export const defaultSpinnerStepClick = (increment, value, step)=>parseInt(value) + (increment ? step : -step);
